import { createBrowserRouter, Navigate, type RouteObject, RouterProvider } from "react-router"
import { HomePage } from "@/domains/login/pages/HomePage/HomePage"
import { LogoutPage } from "@/domains/login/pages/LogoutPage/LogoutPage"
import { useAuthorization } from "@/shared/hooks/useAuthorization"
import { Layout } from "../layout/Layout"
import { AdminRoutes } from "./AdminRoutes"
import { CustomerRoutes } from "./CustomerRoutes"
import { RouterErrorBoundary } from "./RouterErrorBoundary/RouterErrorBoundary"

export function AuthorizedRouter() {
  const { hasAccessToCustomers, isAdmin } = useAuthorization()

  const routes: RouteObject[] = [
    {
      path: "/logout",
      element: <LogoutPage />
    },
    {
      path: "/",
      element: <Layout isUnauthorized={false} />,
      errorElement: <RouterErrorBoundary />,
      children: [
        {
          index: true,
          errorElement: <RouterErrorBoundary />,
          element: hasAccessToCustomers ? <Navigate to="/customers" replace /> : <HomePage />
        },
        {
          path: "home",
          errorElement: <RouterErrorBoundary />,
          element: <HomePage />
        },
        hasAccessToCustomers ? CustomerRoutes : {},
        isAdmin ? AdminRoutes : {},
        {
          path: "auth",
          element: <Navigate to="/" replace />
        },
        {
          path: "*",
          element: <Navigate to="/" replace />
        }
      ]
    }
  ]

  return <RouterProvider router={createBrowserRouter(routes)} />
}
